import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { MultiLineText } from "@root/shared/components/MultiLineText";
import { colors } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";

type Props = {
  tooManyResultErrorText?: string;
  noResultError: boolean;
};

export const PromptToSearchAgainInfo: FC<Props> = ({ tooManyResultErrorText, noResultError }) => {
  return (
    <div className={styles.wrapper}>
      <GuidanceBox themeColor="red">
        <div className={styles.flexWrapper}>
          <Icon color={colors.Danger} name="attention" fontSize="16px" />
          {tooManyResultErrorText ? (
            <MultiLineText text={tooManyResultErrorText} />
          ) : (
            noResultError && <p>ヒットする企業はありませんでした。</p>
          )}
        </div>
      </GuidanceBox>
      {tooManyResultErrorText && (
        <b className={styles.boldText}>より詳細なキーワードで、検索してみましょう。</b>
      )}
    </div>
  );
};
